import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })


export class DevolucionService {

    backendUrl: string = environment.apiUrl;
    url_final: string;

    constructor(private http: HttpClient) {
    }

    consultarOrden(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_orden_to_devolucion?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarDevolucion(entrada_token){
        this.url_final = this.backendUrl + "/rmsfe/devolucion_show"
        this.url_final =
        `${this.url_final}?entrada_token=${entrada_token}`;
        return this.http.get<any>(this.url_final, {observe: 'response'})
        .pipe(map(response => {
          return response;
        }));
    }

    enviarDevolucion(entries, num_guia, paqueteria, seller, inventario, ord_id, file_name, guia_prepagada, alto, largo, ancho, tipo_envio, shipping_platform, peso_reportado, origen, destino, tipo_paquete, label_transaction_id, precio_guia, nombre_paquete){
      this.url_final = this.backendUrl + "/rmsfe/nueva_devolucion"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, num_guia, paqueteria, seller, inventario, ord_id, file_name, guia_prepagada, alto, largo, ancho, tipo_envio, shipping_platform, peso_reportado, origen, destino, tipo_paquete, label_transaction_id, precio_guia, nombre_paquete})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarDireccionOrden(orden_id){
      this.url_final = this.backendUrl + "/rmsfe/consultar_dir_ord_to_dev?shopi_order_id="
      this.url_final = `${this.url_final}${orden_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    getUploadURl(type){
      this.url_final = this.backendUrl + "/rmsfe/generar_upload_url?type=" 
      this.url_final = `${this.url_final}${type}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    subirArchivo(url_metodo, file){
      this.url_final = `${url_metodo}`;
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'binary/octet-stream',
           'Anonymous': '' 
        }),
      };
      var fd = new FormData();
      fd.append('file', file, file.name);
      return this.http.put<any>(this.url_final, fd, httpOptions)
      .pipe(map(response => {
        return response;
      }));
    }

    generar_guia_devoluciones_api(datos_envio){
      this.url_final = this.backendUrl + "/rmsfe/crear_guia_workflow_devoluciones_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {items: datos_envio.items, orden_id: datos_envio.orden_id, paquete_info: datos_envio.paquete_info, paquetes: datos_envio.paquetes, origen: datos_envio.origen, destino: datos_envio.destino})
      .pipe(map(response => {
        return response;
      }));
    }

    get_information_item_rmsfe(item_id){
      this.url_final = this.backendUrl + "/rmsfe/get_information_item?item_id="
      this.url_final = `${this.url_final}${item_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultar_sta_gui(order_id){
      this.url_final = this.backendUrl + "/rmsfe/status_informe_workflow_devoluciones_api?orden_id="
      this.url_final = `${this.url_final}${order_id}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    changeStatus(devolutionId, status){
      this.url_final = this.backendUrl + `/rmsfe/change_status_devolution`
      return this.http.put<any>(this.url_final, {
        devolution_id: devolutionId,
        status: status
      }).pipe(map(response => {
        return response;
      }));
    }

    visualizarImagen(file_name){
      this.url_final = this.backendUrl + "/rmsfe/visualizar_imagen"
      this.url_final =
      `${this.url_final}?file_name=${file_name}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }
    ));
  }
}